import { addYears, format } from 'date-fns';
import { Box, Flex, Text } from 'roo-ui/components';
import { NonWrappingText } from 'components/Typography';

const VoucherExpireLineItem = () => {
  return (
    <Flex justifyContent="space-between" px={5} pb={4} alignItems="baseline">
      <Box pr={5}>
        <Text fontSize="lg" color="greys.charcoal" as="div">
          Expiry date
        </Text>
      </Box>
      <Box textAlign="right">
        <NonWrappingText display="block" fontSize="lg">
          {format(addYears(Date.now(), 3), 'dd MMM, yyyy')}
        </NonWrappingText>
      </Box>
    </Flex>
  );
};

export default VoucherExpireLineItem;
